<template>
  <div>
    <main role="main">
      <BLoading
        class="xb-loading"
        :active.sync="isLoading"
        :can-cancel="false"
        style="z-index: 999;"
      />

      <xbase-top-content
        :breadcrumbsData="breadcrumbsData"
        serviceName="Workspace"
        :isToggleSidebarButtonHidden="true"
      />
      <div>
        <Xbanner
          :userName="modifiedName"
          :handleLogout="!isImpersonating && handleLogout"
          :goToProfileHandler="goToProfileHandler"
          backgroundImgPath="/aceas/assets/common/img/banner.png"
        >
          <template name="additional-information">
            <RESDetailedInformation v-if="profileType == 2" />
          </template>
        </Xbanner>
        <div class="content-container">
          <template v-if="isPIIBrokers && profileType == 1">
            <pii-brokers />
          </template>

          <template v-if="!isPIIBrokers">
            <special-notif-boxes
              :showRenewalBannerFlag="showRenewalBannerFlag"
              :isEnteringRenewalPeriod="isEnteringRenewalPeriod"
              :isEligibleToRenew="isEligibleToRenew"
              :isCanSubmitRenewalDp="isCanSubmitRenewalDp"
              :showDPBannerFlag="showDPBannerFlag"
              :isEligibleToNonRenew="isEligibleToNonRenew"
              :additionalProfileInfo="additionalProfileInfo"
              :hasActiveFlag="hasActiveFlag"
              :hasNonRenewActiveFlag="hasNonRenewActiveFlag"
              :isRESAlreadyRenewed="isRESAlreadyRenewed"
              :isEAAlreadyRenewed="isEAAlreadyRenewed"
              @triggerLoading="setLoadingTo"
            />

            <template
              v-if="
                (profileType == 1 && isEnteringRenewalPeriod.status) ||
                  (profileType === 2 && isRESRegistered)
              "
            >
              <cta-section />
            </template>

            <template
              v-if="profileType === 1 && isEnteringRenewalPeriod.status"
            >
              <dp-details />
            </template>

            <!-- New aggregate count -->
            <!-- <pending-ea-action v-if="profileType === 1" /> -->

            <!-- Old count -->
            <old-pending-ea-action v-if="profileType === 1" />

            <!-- active application section -->
            <active-applications :profileType="profileType" />

            <!-- drafts section -->
            <drafts :profileType="profileType" />
          </template>
        </div>
      </div>
    </main>
    <xbase-footer
      title="ACEAS"
      latestUpdate="16 Aug 2020"
      :services="serviceMenu"
      :links="footerAdditionalLinks"
    />
  </div>
</template>

<script>
const mapState = window.Vuex.mapState;
const mapGetters = window.Vuex.mapGetters;

import ActiveApplications from "./sections/ActiveApplications.vue";
import Drafts from "./sections/Drafts.vue";
// import PendingEaAction from "./sections/PendingEaAction.vue"; // Using aggregate count
import OldPendingEaAction from "./sections/OldPendingEaAction.vue"; //Using old Api
import DpDetails from "./sections/DPDetails.vue";
import SpecialNotifBoxes from "./sections/SpecialNotifBoxes.vue";
import CtaSection from "./sections/CtaSection.vue";
import PiiBrokers from "./sections/PiiBrokers.vue";
import RESDetailedInformation from "./sections/RESDetailedInformation.vue";

import Mgr from "./../../services/securityService";
import baseService from "./../../services/index";

export default {
  name: "Workspace",
  components: {
    ActiveApplications,
    Drafts,
    // PendingEaAction, // Using Aggregate count
    OldPendingEaAction, // Using old API
    DpDetails,
    SpecialNotifBoxes,
    CtaSection,
    PiiBrokers,
    RESDetailedInformation
  },
  computed: {
    ...mapState({
      serviceMenu: state => state.header.serviceMenu,
      headerPath: state => state.header.headerPath,
      footerAdditionalLinks: state => state.footer.links,
      userName: state => state.header.userProfile.userName,
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken,
      sgID: state => state.header.userProfile.sgID,
      additionalProfileInfo: state =>
        state.header.userProfile.additionalProfileInfo,
      profileType: state => state.header.userProfile.profileType, //1 for EA, 2 for RES
      isImpersonating: state => state.header.isImpersonating
    }),
    ...mapGetters({
      serviceMenu: "menus/headers"
    }),
    isRESRegistered() {
      return this.additionalProfileInfo &&
        this.additionalProfileInfo.registrationStatus == "Un-registered"
        ? false
        : true;
    },
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    },
    isPIIBrokers() {
      return this.$store.state.header.userProfile.roles.includes("pii-brokers");
    },
    isEligibleToRenew() {
      return this.profileType == 2
        ? this.isRESEligibleToRenew
        : this.isEAEligibleToRenew;
    },
    isEligibleToNonRenew() {
      return this.profileType == 2
        ? this.isRESEligibleToNonRenew
        : this.isEAEligibleToNonRenew;
    },
    modifiedName() {
      if (
        this.$store.state.header.userProfile.userName ===
          this.$store.state.header.userProfile.nric ||
        this.$store.state.header.userProfile.userName ===
          this.$store.state.header.userProfile.sgID
      )
        return this.$options.filters.maskNRIC(
          this.$store.state.header.userProfile.userName
        );
      else {
        return this.$store.state.header.userProfile.userName;
      }
    }
  },
  data: function() {
    return {
      mgr: new Mgr(this.$store.state.config.configurationData.common_module),
      breadcrumbsData: [
        {
          name: "Workspace",
          path: "/"
        }
      ],
      showRenewalBannerFlag: false,
      isEnteringRenewalPeriod: {
        status: false,
        deadlineDate: null
      },
      isLoading: false,
      isEAEligibleToRenew: false,
      isRESEligibleToRenew: false,
      isEAEligibleToNonRenew: false,
      isRESEligibleToNonRenew: false,
      isCanSubmitRenewalDp: false,
      showDPBannerFlag: false,
      hasActiveFlag: false,
      hasNonRenewActiveFlag: false,
      isRESAlreadyRenewed: true,
      isEAAlreadyRenewed: true
    };
  },

  mounted() {
    this.fetchIsEnteringRenewalPeriodStatus();
    this.checkCanSubmitRenewalDp();

    this.$nextTick(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  },

  methods: {
    setLoadingTo(value) {
      this.isLoading = value;
    },
    handleLogout() {
      this.$emit("logout", true);
      this.$store.commit("auth/setIsManuallySignedOut", true);
      this.isLoading = true;
      this.mgr.signOut().catch(e => {
        return e;
      });
    },
    goToProfileHandler() {
      this.$router.push({ path: "/profile-management/profile" });
    },

    fetchIsEnteringRenewalPeriodStatus() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getCheckRenewalPeriodEndpoint;

      baseService(
        endpoint,
        {},
        this.setIsEnteringRenewalPeriodStatus,
        this.handleFailed,
        this.headerOptions
      );
    },
    setIsEnteringRenewalPeriodStatus(response) {
      const isEnteringRenewalPeriod = response.data.data.renewalPeriod;
      const deadlineDate = this.$_globalMixin_displaySGT(
        new Date(response.data.data.endPeriod),
        "d MMM yyyy"
      );
      this.isEnteringRenewalPeriod.status = isEnteringRenewalPeriod;
      this.isEnteringRenewalPeriod.deadlineDate = deadlineDate;

      if (this.isEnteringRenewalPeriod.status) {
        if (this.profileType === 1) {
          this.getEligibilityStatus();
          this.getNonRenewalEligibilityStatus();
        } else {
          this.getRESEligibilityStatus();
          this.getRESNonRenewalEligibilityStatus();
        }
      }
    },

    getNonRenewalEligibilityStatus() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getEANonRenewalEligibilityEndpoint;

      baseService(
        endpoint,
        {},
        this.decideNonRenewalEligibility,
        this.handleFailed,
        this.headerOptions
      );
    },

    decideNonRenewalEligibility(response) {
      const isEAEligibleToApplyNonRenewal = response.data.data.eligibleFlag;
      this.isEAEligibleToNonRenew = isEAEligibleToApplyNonRenewal;

      this.hasNonRenewActiveFlag = response.data.data.hasActiveFlag;
    },

    getEligibilityStatus() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getEAEligibilityEndpoint;

      baseService(
        endpoint,
        {},
        this.decideEligibility,
        this.handleFailed,
        this.headerOptions
      );
    },

    decideEligibility(response) {
      const alreadyRenewed = response.data.data.alreadyRenewed;
      this.isEAAlreadyRenewed = alreadyRenewed;
      if (!alreadyRenewed) {
        const isEAEligible = response.data.data.eligibleFlag;
        this.isEAEligibleToRenew = isEAEligible;

        this.hasActiveFlag = response.data.data.hasActiveFlag;
      }
    },

    getRESNonRenewalEligibilityStatus() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getRESNonRenewalEligibilityEndpoint;
      baseService(
        endpoint,
        {},
        this.decideRESNonRenewalEligibility,
        this.handleFailed,
        this.headerOptions
      );
    },

    decideRESNonRenewalEligibility(response) {
      const isRESEligibleToApplyNonRenewal = response.data.data.eligibleFlag;
      this.isRESEligibleToNonRenew = isRESEligibleToApplyNonRenewal;

      this.hasNonRenewActiveFlag = response.data.data.hasActiveFlag;
    },

    getRESEligibilityStatus() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getRESEligibilityEndpoint;

      baseService(
        endpoint,
        {},
        this.decideRESEligibility,
        this.handleFailed,
        this.headerOptions
      );
    },

    decideRESEligibility(response) {
      const alreadyRenewed = response.data.data.alreadyRenewed;
      const showBannerFlag = response.data.data.showBannerFlag;
      const showDPBannerFlag = response.data.data.showDPBannerFlag;

      this.isRESAlreadyRenewed = alreadyRenewed;
      this.showRenewalBannerFlag = showBannerFlag;
      this.showDPBannerFlag = showDPBannerFlag;

      if (!alreadyRenewed) {
        const isRESEligible = response.data.data.eligibleFlag;
        this.isRESEligibleToRenew = isRESEligible;

        this.hasActiveFlag = response.data.data.hasActiveFlag;
      }
    },
    checkCanSubmitRenewalDp() {
      const endpoint = this.apiConfig.common_module.eaLicenceRenewal.dp
        .canSubmit;
      baseService(
        endpoint,
        {},
        this.setIsCanSubmitRenewalDp,
        this.handleFailed,
        this.headerOptions,
        "get"
      );
    },
    setIsCanSubmitRenewalDp(response) {
      this.isCanSubmitRenewalDp = response.data.data;
    },
    handleFailed(e) {
      return e.message;
      // retriger changes //
    }
  }
};
</script>

<style lang="scss">
.xb-table-wrapper {
  min-height: 0;
}

.xb-cards .xb-notifier-card {
  margin-bottom: 20px;
}

@media only screen and (max-width: 767px) {
  .xb-header {
    .nav-wrapper {
      left: 0;
      width: 100%;

      .nav-button {
        padding-left: 35px;
      }

      .nav-dropdown.expanded {
        left: 0;
      }
    }
  }
}
</style>
